"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard,
  Autoplay,
} from "swiper/modules";
import Image from "next/image";
import useSliders from "@/hooks/useSliders";
import { SliderType } from "@/types/SliderType";
import Link from "next/link";
import SliderSkeleton from "@/components/Skeleton/SliderSkeleton";
function SliderSection() {
  const { data: sliderList = [], isLoading } = useSliders();
  const sliderImage = `w-full h-full object-cover mb-5`;
  return (
    <>
      {isLoading ? (
        <SliderSkeleton />
      ) : (
        <Swiper
          loop={true}
          cssMode={true}
          navigation={true}
          pagination={true}
          mousewheel={true}
          keyboard={true}
          centeredSlides={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          modules={[Navigation, Pagination, Mousewheel, Keyboard, Autoplay]}
          className="mySwiper"
        >
          {sliderList?.map((slider: SliderType, index: number) => (
            <SwiperSlide key={slider.id}>
              <Link className="w-full" href={slider.link || "/"}>
                <Image
                  src={slider.longImageName}
                  alt={slider?.mainTitle || "اسلایدر"}
                  width={1600}
                  height={600}
                  sizes="100vw"
                  priority={index === 0}
                  fetchPriority={index === 0 ? "high" : "auto"}
                  className="w-full h-auto object-cover mb-5"
                />
                <Image
                  unoptimized
                  width={10000}
                  height={3000}
                  className={`${sliderImage} lg:hidden flex`}
                  alt={slider?.mainTitle || "اسلایدر"}
                  src={slider?.shortImageName}
                />
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </>
  );
}

export default SliderSection;
